import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Payload {
  documentUuid: string;
}

export default (makeCall: MakeCall) =>
  (conversationId: number, data: Payload) =>
    makeCall<Conversation>(
      'PUT',
      `/api/v2/conversation/${conversationId}/document`,
      { data },
    );
